import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { getDateAsObject } from "../../core/et3-date";
import { TGender, TGetKhattabaClients } from "../../Types";
import { post } from "../axios-post";

export const apiCallGetKhattabaAiClients = async ({
  gender,
  startDate,
  endDate,
  applicationStatus,
  stats,
  userID
}: {
  gender: TGender;
  startDate: Date;
  endDate: Date;
  applicationStatus: string;
  stats: string[];
  userID: number;
}): Promise<{
  data: TGetKhattabaClients[];
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<TGetKhattabaClients[]>(
    `khattabat/getKhattabaAiClients`,
    {
      gender,
      startDateObject: getDateAsObject(startDate),
      endDateObject: getDateAsObject(endDate),
      status: applicationStatus,
      stats,
      userID
    }
  );
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: [],
      status: "ERROR",
      code: "ERROR"
    };
  }
};
